import { Container } from '@mantine/core'
import { useFirebase } from 'firebase/useFirebase'
import { Suspense, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useCustomizerStore } from 'store/customizerStore'
import { Loader, UserButtonProps } from '../common'
import { UserHeader } from './UserHeader'
import { VerticalSidebar } from './VerticalSidebar'
import classes from './PanelView.module.css'

interface PanelViewProps {
  user: UserButtonProps
  onLogout: () => void
}

export const PanelView = ({ user, onLogout }: PanelViewProps) => {
  const isSidebarCollapsed = useCustomizerStore(state => state.sidebarCollapsed)
  const checkNotificationsState = useFirebase()
  const previousSidebarCollapsed = useRef(isSidebarCollapsed)
  const [sidebarTransition, setSidebarTransition] = useState<
    'expanding' | 'collapsing' | null
  >(null)

  useLayoutEffect(() => {
    if (previousSidebarCollapsed.current === isSidebarCollapsed) return
    setSidebarTransition(isSidebarCollapsed ? 'collapsing' : 'expanding')
    previousSidebarCollapsed.current = isSidebarCollapsed
  }, [isSidebarCollapsed])

  useEffect(() => {
    const abortController = new AbortController()
    checkNotificationsState(abortController.signal)

    return () => {
      abortController.abort()
    }
  }, [])

  return (
    <div
      className={[
        classes.wrapper,
        sidebarTransition && classes[sidebarTransition],
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ marginLeft: isSidebarCollapsed ? 75 : 280 }}
    >
      <VerticalSidebar />
      <div className={classes.content}>
        <UserHeader user={user} onLogout={onLogout} />
        <Container p="lg" size={2200} className={classes.container}>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Container>
      </div>
    </div>
  )
}
